import React from 'react';
import { Snackbar } from '../components/snackbar';
import { FormattedMessage } from 'react-intl';
import { LOADING, COMPLETE, TENANTS_SET_MENU_ITEMS, TENANTS_SET_MENU_ITEM, TENANTS_GET_INSTITUTION_REQUIREMENTS_OK } from './types';
import { call } from '../utilities/http';
import { getPagesForTenant } from '../utilities/roles';

const defaultState = {
    menu: undefined,
    requirements: undefined
};

/**
 * Tenants state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case TENANTS_SET_MENU_ITEMS:
            let { role } = action;
            return { ...state, menu: getPagesForTenant(role) };

        case TENANTS_SET_MENU_ITEM:
            let { location, label } = action;
            const item = state.menu.find(m => (m.locations || []).includes(location)) || {};

            if (!item || item.label === label) {
                return state;
            }

            const stringLabel = typeof label === 'string' ? label : label.props.defaultMessage.toLowerCase();
            const stringItelmLabel = typeof item.label === 'string' ? label : item.label.props.defaultMessage.toLowerCase();

            if (typeof label === typeof item.label && stringLabel === stringItelmLabel) {
                return state;
            }

            const index = state.menu.indexOf(item);
            const menu = [...state.menu.filter(m => m.icon !== item.icon)];
            menu.splice(index, 0, { ...item, label });
            return { ...state, menu };

        case TENANTS_GET_INSTITUTION_REQUIREMENTS_OK:
            return { ...state, requirements: action.data };

        default:
            return state;
    }
}

export function setTenant(role, onComplete = () => null) {
    return async function(dispatch) {
        dispatch({ type: TENANTS_SET_MENU_ITEMS, role: role });
        onComplete();
    };
}

export function setMenuLabelOfLocation(location, label, onComplete = () => null) {
    return async function(dispatch) {
        dispatch({ type: TENANTS_SET_MENU_ITEM, location, label });
        onComplete();
    };
}

// ------------------------------------------------
// Onboarding - activate institution / requirements
// ------------------------------------------------

export function submitInstitutionForApproval(role, onSuccess = () => null) {
    let errorMessage = <FormattedMessage id={'error.submitInstitutionForApproval'} defaultMessage={'Unable to submit institution changes for approval.'} />;
    const { id, type } = role;

    return async function(dispatch) {
        dispatch({ type: LOADING });

        call({ path: `/${type}/${id}/action/approve`, method: 'POST' })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                Snackbar.error(errorMessage);
            });
    };
}

export function getRequirements(role, onSuccess = () => null) {
    let errorMessage = <FormattedMessage id={'error.getRequirements'} defaultMessage={'Unable to retrieve institution requirements.'} />;
    const { id, type } = role;

    return async function(dispatch) {
        dispatch({ type: LOADING });

        call({ path: `/${type}/${id}/required` })
            .then(response => {
                dispatch({ type: TENANTS_GET_INSTITUTION_REQUIREMENTS_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                Snackbar.error(errorMessage);
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/tenants.jsx